import { memo } from "react";
import { PaymentModeAndAdditionInfoTablePanel } from "./Table/PaymentModeAndAdditionInfoTablePanel";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import PaymentModeAndAdditionEditPanel from "./PaymentModeAndAdditionEditPanel";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";

const PaymentModeAndAdditionInfoContent: React.FC = () => {
        const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
        const { isShowAddPaymentModePanel } = counterCustomerChargeState;

        return <div className={`main-comp-wrapper${isShowAddPaymentModePanel ? '' : ' im-hide-side-form-draggable'}`}>
                <SliderPanel
                        isOpen={true}
                        draggable={true}
                        leftSectionWidth={!isShowAddPaymentModePanel ? "100%" : "80%"}
                        rightSectionWidth={!isShowAddPaymentModePanel ? "0%" : "20%"}
                        leftChildren={<PaymentModeAndAdditionInfoTablePanel />}
                        rightChildren={<PaymentModeAndAdditionEditPanel />}
                />
        </div>
}

export default memo(PaymentModeAndAdditionInfoContent);